import { createUseStyles } from '@pushpay/styles';
export const footerHeight = '56px';
const sectionStyles = {
  height: '100%',
  display: 'flex',
  alignItems: 'center'
};
const useStyles = createUseStyles(theme => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.colors['color-background-surface'],
    color: theme.colors['palette-grey-dark-300'],
    display: 'flex',
    height: footerHeight,
    justifyContent: 'space-between',
    padding: `0 ${theme.SPACING.MEDIUM}`,
    borderTop: `1px solid ${theme.colors['color-border-surface']}`
  },
  leftSide: { ...sectionStyles
  },
  rightSide: { ...sectionStyles,
    color: theme.colors['color-text-default'],
    fontWeight: 600,
    justifyContent: 'flex-end',
    lineHeight: '20px',
    paddingLeft: theme.SPACING.MEDIUM
  },
  centerDot: {
    color: theme.colors['palette-grey-dark-300'],
    fontSize: '12px',
    margin: '0 12px'
  },
  churchStaqLogo: {
    fontSize: '24px'
  },
  parishStaqLogo: {
    fontSize: '24px'
  },
  pushpayLogo: {
    color: theme.colors['palette-grey-dark-300'],
    fontSize: '32px'
  },
  staqLogo: {
    color: theme.colors['palette-grey-dark-300'],
    fontSize: '24px'
  }
}));
export default useStyles;